import React, { Component } from 'react';
import PropTypes from 'prop-types';
import syncPushState from '../../lib/syncPushState';
import Filter from './Filter';

export default class DropdownFilter extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    options: PropTypes.array,
    selected: PropTypes.string,
    collapse: PropTypes.bool,
    title: PropTypes.string,
    expanded: PropTypes.bool,
    onChange: PropTypes.func,
    defaultValue: PropTypes.string,
    noSpacing: PropTypes.bool
  }

  static defaultProps = {
    collapse: true,
    expanded: false,
    title: null,
    options: [],
    selected: null,
    defaultValue: null,
    onChange() {},
    noSpacing: false
  }

  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
    };
  }

  handleChange = (e) => {
    const { value } = e.target;
    const selected = value;
    this.setState({ selected }, () => {
      syncPushState(this.props.id, selected);
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  handleLocalResetClick = () => {
    const selected = null;
    this.setState({ selected }, () => {
      syncPushState(this.props.id, selected);
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  handleGlobalResetClick = () => {
    const selected = null;
    this.setState({ selected }, () => {
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  render() {
    const {
      id, title, expanded, onChange, collapse, noSpacing
    } = this.props;

    const defaultValue = this.state.selected || this.props.defaultValue || "";
    return (
      <Filter noSpacing={noSpacing} id={id} title={title} expanded={expanded} hasSelected={this.state.selected !== null} onChange={onChange} onLocalReset={this.handleLocalResetClick} onGlobalReset={this.handleGlobalResetClick} collapse={collapse}>
        <div className={`Form ${this.props.noSpacing ? '' : 'u-px-4 u-pb-2'}`}>
          <select name={this.props.id} key={this.props.id} id={this.props.id} className={`u-text-sm ${this.props.noSpacing ? '' : 'u-mb-2 '}`} onChange={this.handleChange} value={defaultValue}>
            <option value="" disabled hidden>Select {this.props.title}</option>
            {this.props.options.map((option) => {
              return (
                <option value={option.id} key={option.id}>{option.name}</option>
              );
            })}
          </select>
        </div>
      </Filter>
    );
  }
}
